
/**
 * 모델
 * @window w_tb_ca602w_02
 * @category 재고이동내역
 */
export class InventoryMovementModel {
  /**
   * 회사코드
   *
   * **data type** varchar(8)
   */
  custcd: string;

  /**
   * 사업장코드
   *
   * **data type** varchar(8)
   */
  spjangcd: string;

  /**
   * 제품코드
   *
   * **data type** varchar(8)
   */
  pcode: string;

  /**
   * 제품명
   *
   * **data type** varchar(8)
   */
  pname: string;

  /**
   * 규격
   *
   * **data type** varchar(8)
   */
  psize: string;

  /**
   * 규격
   *
   * **data type** varchar(8)
   */
  punit: string;

  /**
   * 개수
   *
   * **data type** varchar(8)
   */
  numcnt: string;

  /**
   * 출고
   *
   * **data type** varchar(8)
   */
  outcnt: string;

  /**
   * 현재고
   *
   * **data type** varchar(8)
   */
  qty: string;

  /**
   * 모름
   *
   * **data type** varchar(8)
   */
  kname: string;

  /**
   * 년도
   *
   * **data type** varchar(8)
   */
  year: string;

  /**
   * 번호
   *
   * **data type** varchar(8)
   */
  num: string;

  constructor(data: any = {}) {
    this.custcd = data.custcd || '';
    this.kname = data.kname || '';
    this.numcnt = data.numcnt || '';
    this.outcnt = data.outcnt || '';
    this.pcode = data.pcode || '';
    this.pname = data.pname || '';
    this.psize = data.psize || '';
    this.punit = data.punit || '';
    this.qty = data.qty || '';
    this.spjangcd = data.spjangcd || '';
    this.year = data.year || '';
    this.num = data.num || '';
  }
}
